import { Component, Inject, Input, OnChanges, OnInit } from '@angular/core';
import { ApplicationFacade, DropOffType, PickupType, ShapeType, Agency } from '@ridango/components';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-route-name',
    templateUrl: './route-name.component.html',
    styleUrls: ['./route-name.component.scss']
})
export class RouteNameComponent implements OnChanges, OnInit {
    readonly PickupType = PickupType;
    readonly DropOffType = DropOffType;
    assetsPath$ = this.applicationFacade.assetsPath$;
    @Input() routeNumberLabel: string;
    @Input() routeNumberColor: string;
    @Input() routeNumberTextColor: string;
    @Input() routeNumberShape: ShapeType = ShapeType.ROUNDED;
    @Input() name: string;
    @Input() isLive: boolean = null;
    @Input() delay: number = null;
    @Input() pickupType: PickupType;
    @Input() dropOffType: DropOffType;
    @Input() cancelled: boolean | null = null;
    @Input() agency: Agency;
    @Input() operatorCode: string | null = null;
    @Input() operatorName: string | null = null;
    isOnTime: string = null;
    operatorLogosBaseUrl: string;
    operatorLogoFileExists = true;

    constructor(
        protected applicationFacade: ApplicationFacade,
        @Inject('ENV') public env: Env
    ) {
        this.setIsOnTime();
    }

    ngOnInit(): void {
        this.operatorLogosBaseUrl = `${this.env.STATIC_CONTENT_BASE_URL}/${this.env.APP_NAME}/operator_logos/`;
    }

    ngOnChanges(): void {
        if (this.delay !== null && this.isLive) {
            this.setIsOnTime();
        }
    }

    setIsOnTime(): string | void {
        if (this.delay > this.env.EXPLORE?.ROUTE_DETAIL_LATE_THRESHOLD) {
            this.isOnTime = 'LATE';
        }

        if (this.delay < -this.env.EXPLORE?.ROUTE_DETAIL_EARLY_THRESHOLD) {
            this.isOnTime = 'EARLY';
        }
    }
}
